import { createContext } from "react";
const UserProfileProvider = createContext();
export default UserProfileProvider;
